module.exports = __webpack_public_path__ + "img/arrow_plate_prev.e94b1460.svg";